import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  label
}: {
  label?: string;
}) {
  return <div className="flex items-center gap-1" role="img" aria-label={label ?? 'Calificación 5 de 5 estrellas'} data-id="element-243" data-mp="2xx81qyhycrrk">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-244" data-mp="2oxbkvj1t0x72" data-mpi={i} />)}
    </div>;
}